import { Option } from "../../../models/formModel";

export const REJECT_REASONS: Array<Option> = [
    { value: 'MOI', label: 'Monto de oferta' },
    { value: 'FMI', label: 'Fecha de mudanza' },
    { value: 'PCI', label: 'Periodo de contrato' }
]